var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { addZeroToDate } from '../../../utils';
export const DzDateTimePicker = ({ name, formik, label, className, minDate, maxDate, defaultCalendarMonth, disablePast, onChange, }) => {
    const onDateChange = useCallback((date) => {
        if (onChange) {
            return onChange(date);
        }
        let correctDate = '';
        if (date) {
            // @TODO: Refactor with date-utils
            correctDate = `${date.getFullYear()}-${addZeroToDate(date.getMonth() + 1)}-${addZeroToDate(date.getDate())} 00:00:00`;
        }
        formik.setFieldValue(name, correctDate);
    }, [formik, name]);
    return (_jsx(DatePicker, { renderInput: (_a) => {
            var params = __rest(_a, []);
            return (_jsx(TextField, Object.assign({}, params, { name: name, label: label, error: Boolean(formik.errors[name]), helperText: formik.errors[name], className: className })));
        }, value: formik.values[name], onChange: onDateChange, minDate: minDate ? new Date(minDate) : undefined, maxDate: maxDate ? new Date(maxDate) : undefined, defaultCalendarMonth: defaultCalendarMonth ? new Date(defaultCalendarMonth) : undefined, disablePast: disablePast }));
};
